<template>
    <div class="body">
        <div :class="[{'has-margin-bottom':isMobile},'session-second-wrap']">
            <hero :info="heroInfo" v-if="heroInfo"></hero>
            <troop :info="troopInfo" v-if="troopInfo"></troop>
            <foot></foot>
        </div>
        <mb-bar :info="barInfo" :lan="language" v-if="barInfo"></mb-bar>
        <loading v-if="loading"></loading>
    </div>
</template>
<style lang="less" scoped>
    .body {
        background: #241F16;
    }
    .session-one-wrap {
        height: 6.16rem;
    }
    .session-second-wrap {
        padding-top: .32rem;
    }
    .has-margin-bottom {
        margin-bottom: 1.33333rem;
    }
</style>
<script>
    import caocao from '@/assets/images/img-hero-01-caocao.png'
    import caoren from '@/assets/images/img-hero-01-caocao.png'
    import hero_prev from '@/assets/images/hero-prev.png'
    import hero_next from '@/assets/images/hero-next.png'
    import Util from "@util/index.js";
    import controller from "@controller/hero.js"
    import foot from '@components/common/foot/index.vue'
    import mbBar from '@components/common/bar/index.vue'
    import hero from '@components/hero/heroes-tab.vue'
    import troop from '@components/hero/troop-tab.vue'
    import loading from '@components/common/loading/index.vue'
    export default {
        props: ['info'],
        components: {
            mbBar,
            foot,
            hero,
            troop,
            loading
        },
        asyncData(payload) {
            if (process.server) {
                const dataInfo = payload['payload']['picData'];
                // console.log('........................')
                // console.log(JSON.stringify(dataInfo.gameItemInfo))
                const info = controller.initPic(dataInfo.list);
                const barInfo = controller.initBarInfo(dataInfo.gameItemInfo, payload['payload'].webMark, payload['payload'].isPreference, payload['payload'].lan, payload['payload'].testPath);
                const heroBar = controller.initHeroBar(dataInfo.gameItemInfo, payload['payload'].webMark);
                const pcBarInfo = controller.getPCBarInfo(dataInfo.list, payload['payload'].isPreference, payload['payload'].lan)
                // console.log('......                  .........')
                // console.log(JSON.stringify(pcBarInfo))
                return {
                    language: payload['payload'].language,
                    faviconIcon: payload['payload'].faviconIcon,
                    gameCode: payload['payload'].gameCode,
                    seoInfo: payload['payload'].seoInfo,
                    allInfo: heroBar,
                    barInfo: Object.assign({
                        path: 'hero'
                    }, barInfo, pcBarInfo),
                    heroInfo: {
                        titlePic: info.picInfo.hero_title_pic,
                        ctrl: {
                            prev: hero_prev,
                            next: hero_next
                        },
                        tab: heroBar.tab,
                        tabpic: info.picInfo.general_bar_bg,
                        normalBg: heroBar.normalBg,
                        activeBg: heroBar.activeBg,
                        general_color: heroBar.general_color,
                        heroList: {
                            bot: true,
                            dot: false,
                            botBtn: {},
                            picList: []
                        },
                    },
                    troopInfo: {
                        troop_title: info.picInfo.soldier_title_pic,
                        troop_type: {
                            bg: info.picInfo.soldier_bar_bg,
                            text: info.troopInfo.title,
                            img: info.troopInfo.img
                        }
                    }
                }
            }
        },
        data() {
            return {
                isMobile: false,
                loading: true
            }
        },
        head() {
            return {
                title: this.seoInfo.title,
                link: [{
                    rel: 'icon',
                    href: this.faviconIcon
                }, ],
                meta: [{
                        'property': 'og:url',
                        name: 'url',
                        content: this.seoInfo.url
                    },
                    {
                        'property': 'og:image',
                        name: 'image',
                        content: this.seoInfo.image
                    },
                    {
                        'property': 'og:title',
                        name: 'title',
                        content: this.seoInfo.title
                    },
                    {
                        'property': 'og:description',
                        name: 'description',
                        content: this.seoInfo.description
                    },
                    {
                        'property': 'og:keywords',
                        name: 'keywords',
                        content: this.seoInfo.keyword
                    }
                ]
            }
        },
        mounted() {
            this.loading = false;
            Util.deviceType() == 'mb' ? this.isMobile = true : this.isMobile = false;
            Util.addSesstion('gameCode', this.gameCode);
            Util.addSesstion('ga-id', this.seoInfo.ga);
        },
    }
</script>



// WEBPACK FOOTER //
// client/smsgz/pages/hero.vue